// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog{overflow:auto;-ms-scroll-chaining:none;overscroll-behavior:contain;width:clamp(300px,800px,calc(100% - 16px));max-height:90vh;-ms-flex-item-align:center;align-self:center;justify-self:center;padding:16px 24px;border-radius:4px;background-color:#eee;color:#222}@media (max-width:600px){.dialog{padding:12px}}", ""]);
// Exports
module.exports = exports;
